import { useEffect, useState } from 'react';
import { getExternalStoreMessages, useAuiState, useThreadRuntime } from '@assistant-ui/react';
import type { UIMessage } from 'ai';
import { loadServerThreadMessages, subscribeThreadMeta } from '@/server-threads';
import { mergeSavedMessages } from './chat-follow';

// A followed chat's saved copy, merged into the open pane by message id when
// the chat was re-read (lib/chat-follow.ts): never while an answer streams,
// and never by remounting, so the answer a follower is reading stays put.
export function FollowMerge({ threadId, enabled }: { threadId: string; enabled: boolean }) {
  const thread = useThreadRuntime();
  const running = useAuiState((state) => state.thread.isRunning);
  const [version, setVersion] = useState(0);
  useEffect(() => subscribeThreadMeta(() => setVersion((value) => value + 1)), []);
  useEffect(() => {
    if (!enabled || running) return;
    const current = thread
      .getState()
      .messages.flatMap((message) => getExternalStoreMessages<UIMessage>(message));
    const merged = mergeSavedMessages(loadServerThreadMessages(threadId), current);
    if (!merged) return;
    thread.importExternalState({
      headId: merged.at(-1)?.id ?? null,
      messages: merged.map((message, index) => ({
        parentId: index ? merged[index - 1].id : null,
        message,
      })),
    });
  }, [enabled, version, running, threadId, thread]);
  return null;
}
